import * as React from 'react';
import { NavLink } from 'react-router-dom';
import { URLs } from 'src/constants/urls';

export interface ISearchResultProps {
    resultItem: Array<any>;
    itemClicked: ()=>void;
}

const SearchResults: React.SFC<ISearchResultProps> = (props: ISearchResultProps) => {
    console.log(props);
    // let url = props.resultItem.length>1 ? URLs.itemDetails.replace(':subItemIds','') : URLs.itemDetails;
    let url = URLs.itemDetails.replace(':subItemIds','');
    props.resultItem.map((item: any, index: number)=>{
        // if(index===0) {
        //     url = url.replace(':itemId', item.id)
        // }
        // else {
            url += item.id + (index === props.resultItem.length -1 ? "" : "-");
        // }
        return url;
    })
    return ( <div>
        <NavLink to={url} onClick={props.itemClicked} className="search-result"><span className="search-link-text">{props.resultItem[props.resultItem.length -1].caption}</span>
            <span className="search-link-description">{
                props.resultItem.map((item: any, index: number)=>{
                    return <span key={index}>{item.caption + (index === (props.resultItem.length -1) ? "" : " > ")}</span>;
                })
            }</span>
        </NavLink>
    </div> );
}

export default SearchResults; 


// WEBPACK FOOTER //
// ./src/components/search/searchResults.tsx